import { Injectable } from "@angular/core";
import { IID_CHECKLIST_GISFO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDChecklistGISFOStore } from "./iidChecklistGISFO.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
    providedIn: 'root'
  })
  @InterfaceDataQuery(InterfaceName.CHECKLIST_GISFO)
  export class IIDChecklistGISFOQuery extends AbstractInterfaceDataQuery<IID_CHECKLIST_GISFO> {
  
    constructor(protected store: IIDChecklistGISFOStore) {
      super(store);
    }
  }
